"use strict";
// セレクトボックスの要素を取得
const admissionSelect = document.getElementById("pAdmissionSelect");
if (admissionSelect) {
    // セレクトボックスの変更イベントを監視
    admissionSelect.addEventListener("change", function () {
        // 選択された値を取得
        const selectedValue = this.value;
        // 値が空でない場合のみ処理を実行
        if (selectedValue) {
            // 選択された値に一致するIDを持つ要素を取得
            const targetElement = document.getElementById(selectedValue);
            // 対象要素が存在する場合、スムーズスクロール
            if (targetElement) {
                const isMobileView = window.innerWidth <= 768;
                const offset = isMobileView ? window.innerWidth * 0.24 : 125;
                const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
                window.scrollTo({
                    top: targetPosition,
                    behavior: "smooth",
                });
            }
        }
    });
}
